// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type HistoryDataValueValue
 * 
 * @export
 */
export type HistoryDataValueValue = boolean | number | string | null;

export function HistoryDataValueValueFromJSON(json: any): HistoryDataValueValue {
    return HistoryDataValueValueFromJSONTyped(json, false);
}

export function HistoryDataValueValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDataValueValue {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    if (typeof json === 'boolean') {
        return json;
    }
    return {} as any;
}

export function HistoryDataValueValueToJSON(json: any): any {
    return HistoryDataValueValueToJSONTyped(json, false);
}

export function HistoryDataValueValueToJSONTyped(value?: HistoryDataValueValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    return {};
}

